export default "__VITE_ASSET__DmXMcWAv__"